function configureLineFriendCountDebugAnalytics(opts) {
  if (opts.gcinstant.platformID !== "line") {
    throw Error("Invalid platform: " + opts.gcinstant.platformID);
  }
  void fetchAndTrackDebugFriendCounts(opts);
}
async function fetchAndTrackDebugFriendCounts(opts) {
  const replicant = await opts.replicantClientPromise;
  const asyncGetters = replicant.asyncGetters;
  if (!(asyncGetters == null ? void 0 : asyncGetters.lineGetDebugFriendCounts)) {
    console.error(
      "Replicant async getter `lineGetDebugFriendCounts` is undefined. Extend Replicant configuration with `extendReplicantConfigForAnalytics`."
    );
    return;
  }
  await opts.gcinstant.waitForFriends();
  const socialFriendIds = opts.gcinstant.socialFriends.map((f) => f.id);
  const linePlayingFriendCount = opts.gcinstant.friendIds.length;
  const { playingFriendCount } = await asyncGetters.lineGetDebugFriendCounts({
    socialFriendIds
  });
  opts.analytics.pushEvent("DebugFriendCounts", {
    socialFriendCount: socialFriendIds.length,
    // Number of playing and non-playing friends reported by LINE
    linePlayingFriendCount,
    // Number of playing friends reported by LINE
    replicantPlayingFriendCount: playingFriendCount
    // Number of friends with a Replicant user
  });
}
export {
  configureLineFriendCountDebugAnalytics
};
